import React, { FunctionComponent } from "react";
import { useTheme } from "@mui/material";
import { Theme } from "@emotion/react";

export const AreaSvgComponent: FunctionComponent = () => {
    const theme = useTheme<Theme>();
    return (
        <svg height="100%" width="100%" viewBox="0 0 150 100">
            <polygon fill={theme.shades.one} points="20 60, 60 20, 120 20, 120 80, 60 90" />
        </svg>
    );
};
